<!-- 商品展示卡片 -->
<template>
	<div class="show_card">
		<!-- 商品图片 -->
		<div class="img_box">
			<img :src="imgUrl" height="110" v-show="imgUrl">
			<div class="text-center" style="line-height: 110px;color: #ccc;" v-show="!imgUrl">暂无图片哦</div>
		</div>
		<!-- 商品标题 -->
		<div class="show_desc">
			<!-- 商品标题 -->
			<div class="titleDesc px-3 pt-1">
				<span>{{titleDesc.substr(0,22)}}</span>
				<!-- 商品分类 -->
				<div class="patent_type">
					<span>{{patentType}}</span>
				</div>
			</div>
			<!-- 商品价格 -->
			<div class="patent_price">
				<span>{{price.substr(0,16)}}</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		props: {
			imgUrl:{
				type:[String,Number],
				default:''
			},
			titleDesc:{
				type:[String,Number],
				default:''
			},
			patentType:{
				type:String,
				default:''
			},
			price:{
				type:[String,Number],
				default:''
			}
		},
	}
</script>

<style scope>
	.show_card{
		width: 220px;
		height: 250px;
		border: 1px solid #eee;
		background-color: #fff;
		transition:box-shadow 0.5s;
		-webkit-transition:box-shadow 0.5s; 
		cursor: pointer;
	}
	.show_card:hover{
		box-shadow: 5px 5px 4px rgba(0, 0, 0, .12), 5px 5px 5px rgba(0, 0, 0, .04);
		position: relative;
		bottom: 5px;
	}
	.show_card .img_box{
		width: 100%;
		height: 126px;
		overflow: hidden;
		display: block;
		text-align: center;
		line-height: 126px;
		border-bottom: 1px solid #eee;
	}
	/* 商品描述价格等 */
	.show_desc{
		width: 220px;
		height:125px;
	}
	/* 商品标题 */
	.show_desc .titleDesc{
		width: 220px;
		height: 80px;
		position: relative;
	}
	.show_desc .titleDesc span{
		font-size:16px;
	}
	.show_desc .titleDesc .patent_type {
		position: absolute;
		bottom: 0;
	}
	.show_desc .titleDesc .patent_type span{
		font-size: 14px;
		color: #666;
	}
	/* 商品价格 */
	.patent_price{
		width: 220px;
		height: 20px;
		color: #C32A1A;
		padding-top:3px;
	}
	.patent_price span{
		font-size: 20px;
		padding-left: 13px;
		font-weight: 300;
	}
</style>
